import React from 'react';
interface SectionShellProps {
  id?: string;
  tone?: 'dark' | 'darker';
  children: React.ReactNode;
}
export function SectionShell({
  id,
  tone = 'dark',
  children
}: SectionShellProps) {
  return <section id={id} className={`w-full px-4 py-14 sm:px-6 sm:py-20 ${tone === 'dark' ? 'bg-navy-900' : 'bg-navy-950'}`} data-id="element-263" data-mp="2s5hjzizzeeo7">
      <div className="mx-auto w-full max-w-3xl" data-id="element-264" data-mp="2x1y4m37z2awj">{children}</div>
    </section>;
}
interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
}
export function SectionTitle({
  eyebrow,
  title,
  subtitle
}: SectionTitleProps) {
  return <header className="mb-8 text-center" data-id="element-265" data-mp="29755dhqawcl8">
      {eyebrow && <p className="mb-2 text-xs font-bold uppercase tracking-[0.2em] text-sky-400" data-id="element-266" data-mp="2e4wxocuuy0py">
          {eyebrow}
        </p>}
      <h2 className="font-display text-2xl leading-tight text-white sm:text-4xl" data-id="element-267" data-mp="7fs5j736wuw1">{title}</h2>
      {subtitle && <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-sky-100/70 sm:text-base" data-id="element-268" data-mp="ccigxh41v2b4">
          {subtitle}
        </p>}
    </header>;
}